// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingBalls_wrapper__7NvyY","ball":"LoadingBalls_ball__jQz1u","zoom":"LoadingBalls_zoom__FooWt"};